<style src="css/taskDetail.css" scoped></style>
<template>
    <div style="padding-top: .98rem;">
        <div class="topBox"><span class="back" @click="back()"></span>任务详情</div>
        <div class="box">
            <div class="taskDetail">
                <div class="left">
                    <div class="leftTop">
                        <div class="icon"></div>
                        {{groupTitle}}
                    </div>
                    <div class="info">
                        <span>用户姓名</span>：{{userName}}
                    </div>
                    <!--                <div class="info">-->
                    <!--                    <span><div>性</div><div>别</div></span>：{{安吉拉}}-->
                    <!--                </div>-->
                    <div class="info">
                        <span>联系方式</span>：{{userPhone}}
                    </div>
                    <div class="info">
                        <span>测试时间</span>：{{groupComboTime | time }}
                    </div>
                    <div class="info" v-if="scaleGroupComboWork.workStatus==3">
                        <span>拒绝原因</span>：{{scaleGroupComboWork.remark }}
                    </div>
                </div>
                <div class="right" @click="startPhoneCall"></div>
            </div>
            <div class="scaleBox">
                <div class="scaleItem" v-for="item in scaleGroupComboRecordDTOList">
                    <div class="scaleInfoBox">
                        <img class="scaleImg" :src="EnvUrl+item.pic" alt="">
                        <div class="scaleWordBox">
                            <div class="scaleTitle">{{item.title}}</div>
                            <div class="tagline">{{item.tagline}}</div>
                        </div>
                    </div>
                    <div class="seeBtn" @click="see(item.testId)">查看</div>
                </div>
            </div>
            <div class="title">电话回访记录</div>
            <textarea placeholder="可选填" v-model="phoneNote"></textarea>
            <div class="title">咨询师总结建议</div>
            <textarea v-model="advice"></textarea>
            <div class="title">矫正方案</div>
            <div class="programme">
                <div class="term"><span>*</span>入矫评估（单选）</div>
                <div class="line"></div>
                <div class="contentBox">
                    <div class="optionBox" @click="changeComboLevel(0)">
                        <div class="optionIcon" :class="{active:comboLevel===0}"></div>
                        正常
                    </div>
                    <div class="optionBox" @click="changeComboLevel(1)">
                        <div class="optionIcon" :class="{active:comboLevel===1}"></div>
                        轻度
                    </div>
                    <div class="optionBox" @click="changeComboLevel(2)">
                        <div class="optionIcon" :class="{active:comboLevel===2}"></div>
                        中度
                    </div>
                    <div class="optionBox" @click="changeComboLevel(3)">
                        <div class="optionIcon" :class="{active:comboLevel===3}"></div>
                        重度
                    </div>
                </div>
                <div class="line"></div>
                <div class="term"><span>*</span>心理矫正措施（多选）</div>
                <div class="line"></div>
                <div class="measureTypeBox">
                    <div  v-for="(item,index) in scaleGroupComboWorkItems">
                        <div class="measureTypeItem" @click="changeMeasureType(index)">
                            <div class="optionIcon" :class="{active:item.selected}"></div>
                            {{item.itemName}}
                            <div style="color: #00C59F;margin-left: .1rem">{{item.times | isTimes}}</div>
                        </div>
                        <div class="frequencyBox" v-if="item.selected">
                            <div class="frequency" @click="changeTimes(48,index)">
                                <div class="optionIcon" :class="{active:item.times===48}"></div>
                                1次/周
                            </div>
                            <div class="frequency" @click="changeTimes(12,index)">
                                <div class="optionIcon" :class="{active:item.times===12}"></div>
                                1次/月
                            </div>
                            <div class="frequency" @click="changeTimes(4,index)">
                                <div class="optionIcon" :class="{active:item.times===4}"></div>
                                1次/季度
                            </div>
                            <div class="frequency" @click="changeTimes(2,index)">
                                <div class="optionIcon" :class="{active:item.times===2}"></div>
                                1次/半年
                            </div>
                        </div>
                    </div>

<!--                    <div class="measureTypeItem" @click="changeMeasureType(0)">-->
<!--                        <div class="optionIcon" :class="{active:measureType===0}"></div>-->
<!--                        线上心理咨询-->
<!--                    </div>-->
<!--                    <div class="measureTypeItem" @click="changeMeasureType(1)">-->
<!--                        <div class="optionIcon" :class="{active:measureType===1}"></div>-->
<!--                        线上内容学习（视频、文章等）-->
<!--                    </div>-->
<!--                    <div class="measureTypeItem" @click="changeMeasureType(2)">-->
<!--                        <div class="optionIcon" :class="{active:measureType===2}"></div>-->
<!--                        线上矫正评测-->
<!--                    </div>-->
<!--                    <div class="measureTypeItem" @click="changeMeasureType(3)">-->
<!--                        <div class="optionIcon" :class="{active:measureType===3}"></div>-->
<!--                        线下科普讲座-->
<!--                    </div>-->
<!--                    <div class="measureTypeItem" @click="changeMeasureType(4)">-->
<!--                        <div class="optionIcon" :class="{active:measureType===4}"></div>-->
<!--                        线下咨询（沙盘游戏、房树人等）-->
<!--                    </div>-->
<!--                    <div class="measureTypeItem" @click="changeMeasureType(5)">-->
<!--                        <div class="optionIcon" :class="{active:measureType===5}"></div>-->
<!--                        线下专家会诊-->
<!--                    </div>-->
                </div>
<!--                <div class="line"></div>-->
<!--                <div class="term"><span>*</span>时间选择（单选）</div>-->
<!--                <div class="line"></div>-->
<!--                <div class="frequencyBox">-->
<!--                    <div class="frequency" @click="changeTimes(48)">-->
<!--                        <div class="optionIcon" :class="{active:times===48}"></div>-->
<!--                        一周一次-->
<!--                    </div>-->
<!--                    <div class="frequency" @click="changeTimes(12)">-->
<!--                        <div class="optionIcon" :class="{active:times===12}"></div>-->
<!--                        月度一次-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="frequencyBox">-->
<!--                    <div class="frequency" @click="changeTimes(4)">-->
<!--                        <div class="optionIcon" :class="{active:times===4}"></div>-->
<!--                        季度一次-->
<!--                    </div>-->
<!--                    <div class="frequency" @click="changeTimes(2)">-->
<!--                        <div class="optionIcon" :class="{active:times===2}"></div>-->
<!--                        半年一次-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="line"></div>-->
<!--                <div class="term"><span>*</span>咨询总次数(年度) <span style="color: #000;margin-left: .4rem">{{times | isTimes}}</span></div>-->
            </div>
            <div class="title">咨询师签名</div>
            <img class="imgBox" :src="EnvUrl+visitorSignature" alt="" v-if="visitorSignature" @click="aa()">
<!--            <input  @click="aa()" type="text" placeholder="点击签名" v-if="!visitorSignature">-->
            <div class="imgBox" style="padding: .1rem;color: #999" @click="aa()" v-if="!visitorSignature">点击签名</div>
            <div style="display: flex;justify-content: space-around">
                <div class="saveBtn" @click="saveScaleGroupComboWork()">保存</div>
                <div class="saveBtn" @click="commitScaleGroupComboWork()">提交</div>
            </div>

        </div>
        <div class="signatureBox" v-show="showStatus">
            <div class="canvasBox" ref="canvasHW">
                <canvas @touchstart='touchStart'
                        @touchmove='touchMove'
                        @touchend='touchEnd'
                        ref="canvasF"
                        @mousedown="mouseDown"
                        @mousemove="mouseMove"
                        @mouseup="mouseUp"></canvas>
                <div class="btnBox">
                    <button @click="overwrite">重写</button>
                    <button @click="saveWrite">提交签名</button>
                </div>
            </div>
        </div>
        <div class="tipBox" v-if="tipStatus">
            <div class="tip">{{tip}}</div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources,getSourcesJson} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import footerBox from 'components/footer'
    import moment from 'moment/moment'


    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                groupTitle:'',
                groupComboTime:'',
                userName:'',
                userPhone:'',
                scaleGroupComboRecordDTOList:[],
                scaleGroupComboWorkItems:[],
                measureTypeList:[
                    {
                        name:'线上心理咨询',
                        id:0,
                        status:false,
                    },
                    {
                        name:'线上内容学习（视频、文章等）',
                        id:1,
                        status:false,
                    },
                    {
                        name:'线上矫正评测',
                        id:2,
                        status:false,
                    },
                    {
                        name:'线下科普讲座',
                        id:3,
                        status:false,
                    },
                    {
                        name:'线下咨询（沙盘游戏、房树人等）',
                        id:4,
                        status:false,
                    },
                    {
                        name:'线下专家会诊',
                        id:5,
                        status:false,
                    }
                ],
                comboLevel:'',
                measureType:-1,
                times:'',
                phoneNote:'',
                advice:'',
                visitorSignature:'',
                showStatus:false,
                tipStatus:false,
                tip:'',
              scaleGroupComboWork:'',
            }
        },
        components: {
            noMoreData,
            topbar,
            footerBox,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isTimes(value){
                let obj={
                    2:'二次',
                    4:'四次',
                    12:'十二次',
                    48:'四十八次',
                }
                if(value){
                    return obj[value]
                }
            }
        },
        computed: {},
        methods: {
            async startPhoneCall() {
                let data = await getSources("/bear-scale/api/scaleGroupCombo/startPhoneCall.json",{
                    workId:this.$route.query.workId?this.$route.query.workId:'',
                    doctorId:localStorage.getItem('doctorId')
                });
                if (data.status === 0) {
                    if(data.bespeakSwitchPhone){
                        // this.cancle();
                        setTimeout(()=>{
                            this.showTip(`请注意接听来电~`)
                        },200)

                    }else{
                        window.location.href = 'tel://' + data.middleNumber
                    }

                } else {
                    alert(`${data.msg}`)
                }
            },
            showTip(v){
                this.tip=v;
                this.tipStatus=true;
                setTimeout(()=>{
                    this.tipStatus=false;
                },2000)
            },
            back(){
                history.back();
            },
            changeComboLevel(n){
                this.comboLevel=n;
            },
            changeMeasureType(i){
                if(this.scaleGroupComboWorkItems[i].selected){
                    this.scaleGroupComboWorkItems[i].selected=0;
                }else{
                    this.scaleGroupComboWorkItems[i].selected=1;
                }
                // this.measureType=n;
                // this.scaleGroupComboWorkItems[n].status=!this.measureTypeList[n].status;
            },
            changeTimes(n,i){
                this.scaleGroupComboWorkItems[i].times=n;
            },
            see(id){
                this.$router.push(`/result?testId=${id}`)
                // location.href=`https://m.120xinmao.cn/testScale/result?testId=${id}`
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            async getWorkDetail(comboId) {
                let data = await getSources("/bear-scale/api/scaleGroupCombo/getWorkDetail.json",{
                    doctorId:localStorage.getItem('doctorId'),
                    workId:this.$route.query.workId?this.$route.query.workId:''
                });
                if (data.status === 0) {
                    this.scaleGroupComboWork=data.scaleGroupComboWork;
                    this.groupTitle=data.groupTitle;
                    this.userPhone=data.userPhone;
                    this.userName=data.userName;
                    this.groupComboTime=data.groupComboTime;
                    this.scaleGroupComboRecordDTOList=data.scaleGroupComboRecordDTOList;
                    this.comboLevel=data.scaleGroupComboWork.comboLevel;

                    // this.measureType=data.scaleGroupComboWork.measureType;
                    this.times=data.scaleGroupComboWork.times;
                    this.phoneNote=data.scaleGroupComboWork.phoneNote?data.scaleGroupComboWork.phoneNote:'';
                    this.advice=data.scaleGroupComboWork.advice?data.scaleGroupComboWork.advice:'';
                    this.visitorSignature=data.scaleGroupComboWork.visitorSignature?data.scaleGroupComboWork.visitorSignature:'';

                    this.scaleGroupComboWorkItems=data.scaleGroupComboWorkItems;
                    let aa=JSON.parse(data.scaleGroupComboWork.measureTypes)
                    this.measureTypeList.forEach(v=>{
                        aa.forEach(item=>{
                            if(item===v.id){
                                v.status=true
                            }
                        })
                    })
                }else{
                    alert(data.msg)
                }
            },
            read(){
                if(this.emergencyContact&&this.relation&&this.emergencyContactPhone&&this.visitorSignature){
                    this.commitScaleGroupComboWork()
                }
            },
            async saveScaleGroupComboWork(comboId) {
                let data = await getSourcesJson("/bear-scale/api/scaleGroupCombo/saveScaleGroupComboWork.json",JSON.stringify({
                    doctorId:localStorage.getItem('doctorId'),
                    workId:this.$route.query.workId?this.$route.query.workId:'',
                    comboLevel:this.comboLevel,
                    scaleGroupComboWorkItems:this.scaleGroupComboWorkItems,
                    phoneNote:this.phoneNote,
                    advice:this.advice,
                    visitorSignature:this.visitorSignature,
                }));
                if (data.status === 0) {
                    // history.back()
                    alert('保存成功~')
                }else{
                    alert(data.msg)
                }
            },
            async commitScaleGroupComboWork(comboId) {
                let data = await getSourcesJson("/bear-scale/api/scaleGroupCombo/commitScaleGroupComboWork.json",JSON.stringify({
                    doctorId:localStorage.getItem('doctorId'),
                    workId:this.$route.query.workId?this.$route.query.workId:'',
                    comboLevel:this.comboLevel,
                    scaleGroupComboWorkItems:this.scaleGroupComboWorkItems,
                    phoneNote:this.phoneNote,
                    advice:this.advice,
                    visitorSignature:this.visitorSignature,
                }));
                if (data.status === 0) {
                    history.back()
                }else{
                    alert(data.msg)
                }
            },
            aa(){
                this.showStatus=true
            },
            saveWrite(){
                var dataurl = this.$refs.canvasF.toDataURL("image/png");
                console.log("保存签名成功" + dataurl);
                this.getToken(dataurl)

            },
            async getToken(dataurl){
                var that=this;
                var xhr = new XMLHttpRequest();
//设置请求的类型及url
//post请求一定要添加请求头才行不然会报错

                xhr.open('post', '/bear-scale/api/qiniu/obtainPictureUploadToken.json' );
                xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
//发送请求
                xhr.send('');
                xhr.onreadystatechange = function () {
                    console.log(xhr)
                    // 这步为判断服务器是否正确响应
                    if (xhr.readyState == 4) {
                        let data=JSON.parse(xhr.responseText)
                        that.putb64(dataurl,data.token)
                    }
                };
            },
            async putb64(pic,token){
                var that=this;
                var pic = pic.replace(/^.*?,/, '');
                var url = "https://up-z0.qiniup.com/putb64/-1"; //非华东空间需要根据注意事项 1 修改上传域名
                var xhr = new XMLHttpRequest();
                xhr.open("POST", url, true);
                xhr.setRequestHeader("Content-Type", "application/octet-stream");
                xhr.setRequestHeader("Authorization", `UpToken ${token}`);
                xhr.send(pic);

                xhr.onreadystatechange=function(){
                    if (xhr.readyState==4){
                        let data=JSON.parse(xhr.responseText)
                        that.visitorSignature=data.key;
                        that.showStatus=false;
                        console.log(that.visitorSignature)
                    }
                }

            },
            //电脑设备事件
            mouseDown(ev){
                ev = ev || event;
                ev.preventDefault();
                console.log(ev);
                if(1){
                    let obj={
                        x:ev.offsetX,
                        y:ev.offsetY
                    };
                    console.log(obj);
                    this.startX=obj.x;
                    this.startY=obj.y;
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.points.push(obj);
                    this.isDown=true;
                }
            },
            //移动设备事件
            touchStart(ev){
                ev = ev || event;
                ev.preventDefault();
                if(ev.touches.length == 1) {
                    let obj={
                        x:ev.targetTouches[0].clientX,
                        y:ev.targetTouches[0].clientY
                    };
                    this.startX=obj.x;
                    this.startY=obj.y;
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.points.push(obj);
                }
            },
            //电脑设备事件
            mouseMove(ev){
                ev = ev || event;
                ev.preventDefault();
                if(this.isDown){
                    let obj={
                        x:ev.offsetX,
                        y:ev.offsetY
                    };
                    this.moveY=obj.y;
                    this.moveX=obj.x;
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.startY=obj.y;
                    this.startX=obj.x;
                    this.points.push(obj);
                }
            },
            //移动设备事件
            touchMove(ev){
                ev = ev || event;
                ev.preventDefault();
                if(ev.touches.length == 1) {
                    let obj={
                        x:ev.targetTouches[0].clientX,
                        y:ev.targetTouches[0].clientY
                    };
                    this.moveY=obj.y;
                    this.moveX=obj.x;
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.startY=obj.y;
                    this.startX=obj.x;
                    this.points.push(obj);
                }
            },
            //电脑设备事件
            mouseUp(ev){
                ev = ev || event;
                ev.preventDefault();
                if(1){
                    let obj={
                        x:ev.offsetX,
                        y:ev.offsetY
                    };
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.points.push(obj);
                    this.points.push({x:-1,y:-1});
                    this.isDown=false;
                }
            },
            //移动设备事件
            touchEnd(ev){
                ev = ev || event;
                ev.preventDefault();
                console.log(ev);
                if(ev.touches.length == 1) {
                    let obj={
                        x:ev.targetTouches[0].clientX,
                        y:ev.targetTouches[0].clientY
                    };
                    this.canvasTxt.beginPath();
                    this.canvasTxt.moveTo(this.startX, this.startY);
                    this.canvasTxt.lineTo(obj.x, obj.y);
                    this.canvasTxt.stroke();
                    this.canvasTxt.closePath();
                    this.points.push(obj);
                    this.points.push({x:-1,y:-1});
                }
            },
            //重写
            overwrite(){
                this.canvasTxt.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height);
                this.points=[];
            },


        },
        destroyed(){

        },
        mounted() {
            let canvas=this.$refs.canvasF;
            console.log(this.$refs.canvasHW.offsetHeight)
            console.log(this.$refs.canvasHW.offsetWidth)
            canvas.height = 200;
            canvas.width =365;
            this.canvasTxt=canvas.getContext("2d");
            // 在canvas绘制前填充白色背景
            this.canvasTxt.fillStyle = "#fff";
            this.canvasTxt.fillRect(0, 0, canvas.width, canvas.height);
            this.getWorkDetail()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/taskDetail.vue